import HTTPService from "./HTTPService";
import config from "../config";
const useMocks = false;
export default class KimayeService {
  static getOutputUiSheetData(code) {
    if (useMocks === false) {
      const url = `${config.outputUiBaseUrl}/api/source-details/${code}`;
      return HTTPService.makeXHRRequest(url, "GET", null);
    } else {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ data: {} });
        }, 3000);
      });
    }
  }
}
